'use client';

import React from 'react';
import { useCookieConsent } from '../../context/CookieConsentContext';
import { SITE_CONFIG } from '../../../constants';
import AhrefsAnalytics from '../AhrefsAnalytics/AhrefsAnalytics';
import ClarityAnalytics from '../ClarityAnalytics/ClarityAnalytics';
import MatomoAnalytics from '../MatomoAnalytics/MatomoAnalytics';

export default function AnalyticsLoader() {
  const { categories } = useCookieConsent();

  if (!categories.analytics) return null;

  return (
    <>
      <AhrefsAnalytics token={SITE_CONFIG.features.analytics.ahrefs || ''} />
      <ClarityAnalytics clarityId={SITE_CONFIG.features.analytics.clarity || ''} />
      <MatomoAnalytics
        url={SITE_CONFIG.features.analytics.matomo.url || ''}
        siteId={SITE_CONFIG.features.analytics.matomo.siteId || ''}
      />
    </>
  );
}
